import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  return <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-27">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between" data-id="element-28">
        <Link to="/" className="flex items-center gap-2 group" data-id="element-29">
          <div className="w-8 h-8 bg-gray-900 rounded-xl flex items-center justify-center transition-transform group-hover:scale-105" data-id="element-30">
            <Shield className="w-4 h-4 text-white" data-id="element-31" />
          </div>
          <span className="font-bold text-gray-900 text-lg tracking-tight" data-id="element-32">
            Agreexa<span className="text-blue-600" data-id="element-33">™</span>
          </span>
        </Link>

        <div className="flex items-center gap-3" data-id="element-34">
          <Link to="/dashboard" className="hidden sm:block text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors" data-id="element-35">
            Mis acuerdos
          </Link>
          <Link to="/create" data-id="element-36">
            <Button size="sm" data-id="element-37">Crear acuerdo</Button>
          </Link>
        </div>
      </div>
    </nav>;
}